import { Language, Subsidiary } from '@coolblue-development/constants';

export const LocalizedVideoIdMap: Partial<Record<Subsidiary, Partial<Record<Language, string>>>> = {
  [Subsidiary.NL]: {
    [Language.DUTCH]: 'SDR8_ymiOWw',
    [Language.ENGLISH]: 'SDR8_ymiOWw'
  },
  [Subsidiary.BE]: {
    [Language.DUTCH]: 'lyTtwQeTgXo',
    [Language.FRENCH]: 'JI4lATLAVkQ'
  },
  [Subsidiary.DE]: {
    [Language.GERMAN]: 'UwCvA_WZNnc'
  }
};
